
import LoaderForSearch from "../Common/LoaderForSearch";
import SmallLoader from "../Common/smallLoader";

function ITRReportTable(props) {
  const downloadLoader = props?.downloadLoader;
  let finalData = props?.finalData;
  const handleScroll = props?.handleScroll;
  const scrollLoader = props?.scrollLoader;
  const handleDownloadBtn = props?.handleDownloadBtn;

  return (
    <>
      <div className="table-responsive scroll-table report-table-wrapper itr-table">
        {finalData && finalData ? (
          <table className="table last-column">
            <thead>
              <tr>
              <th scope="col" className="text-center">
                  Sr No.
                </th>
              <th scope="col" className="text-center">
                  Client Code
                </th>
                <th scope="col" className="text-center">
                  File Name
                </th>
                
                <th scope="col">
                  From Date
                </th>
                <th scope="col" >
                  To Date
                </th>
                <th scope="col" className="text-center">
                  Status
                </th>
                <th scope="col" className="text-center">
                  Failure Reason
                </th>
                {/* <th className="scrollerthead"></th> */}
                </tr>
            </thead>
            <tbody id="clientrevenue-scroll" onScroll={handleScroll}>
              {finalData &&
                finalData.map((item, index) => {
                  return (
                    <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.partyCode || "-"}</td>
                    <td>{item?.fileName || "-"}</td>
                      <td>{item?.fromDate || "-"}</td>
                      <td>{item?.toDate || "-"}</td>
                      
                      {item?.status === 
                        "Completed" ?
                      <td 
                        className="blue-text"
                        onClick={()=>handleDownloadBtn(item?.partyCode, item?.id)}>
                          {downloadLoader === item?.id ?
                          <SmallLoader />
                        : <>Download File</>
                        } 
                      </td>
          
                      : <td className={`${item?.status === "Fail" ? "red-text" : "yellow-text"}`}>{item?.status}</td>
                      }
                      <td>{item?.failureReason || "-"}</td>

                    </tr>
                  );
                })}
              {scrollLoader && (
                <div className="loader-center">
                  <LoaderForSearch />
                </div>
              )}
            </tbody>
          </table>
        ) : (
          ""
        )}
      </div>
    </>
  );
}
export default ITRReportTable;
